import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const DialogContainer = styled.div`
  background: var(--surface);
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  box-shadow: var(--shadow-lg);
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  background: ${props => props.variant === 'danger' ? 'var(--error-light)' : 'var(--primary-light)'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin: 0 auto 20px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
  color: var(--text-primary);
`;

const Message = styled.p`
  text-align: center;
  color: var(--text-secondary);
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => {
    if (props.variant === 'danger') {
      return `
        background: var(--error);
        color: white;
        border: none;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }
      `;
    } else if (props.variant === 'secondary') {
      return `
        background: var(--surface);
        color: var(--text-primary);
        border: 1px solid var(--border);
        
        &:hover {
          background: var(--hover);
        }
      `;
    }
  }}
`;

const Dialog = ({ isOpen, onClose, title, message, icon, buttons, variant = 'primary' }) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <DialogContainer onClick={e => e.stopPropagation()}>
        <IconContainer variant={variant}>
          {icon}
        </IconContainer>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <ButtonGroup>
          {buttons ? buttons.map((button, index) => (
            <Button
              key={index}
              variant={button.variant}
              onClick={button.onClick}
            >
              {button.text}
            </Button>
          )) : (
            <Button variant="secondary" onClick={onClose}>Close</Button>
          )}
        </ButtonGroup>
      </DialogContainer>
    </Overlay>
  );
};

export default Dialog; 